import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMegaphone } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  feedbackModalOpenState,
  feedbackSourceState,
  patientProfileState,
} from "../../recoil/atoms";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { Button } from "../../components/shared/Button/Button";
import { useBooleanFeatureFlag } from "../../utils/hooks/useFeatureFlag";
import { FeatureFlags } from "../../utils/launchDarklyUtils";
import {
  LandingFeedbackContainer,
  LandingFeedbackCard as StyledFeedbackCard,
  LandingFeedbackCardText,
  LandingFeedbackButtonWrapper,
} from "./LandingFeedback.styles";

export const LandingFeedbackCard: React.FC<{
  buttonSize: "small" | "medium";
}> = ({ buttonSize }) => {
  const { t } = useTranslation();
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useRecoilState(
    feedbackModalOpenState,
  );
  const setFeedbackSource = useSetRecoilState(feedbackSourceState);
  const patientInfo = useRecoilValue(patientProfileState);
  const feedbackName = patientInfo?.user?.first_name || "there";
  const { enabled: isPatientNpsFeedbackEnabled } = useBooleanFeatureFlag(
    FeatureFlags.PatientNpsFeedback,
  );

  if (!isPatientNpsFeedbackEnabled) {
    return null;
  }

  return (
    <LandingFeedbackContainer>
      <StyledFeedbackCard>
        <LandingFeedbackCardText>
          {GetTypographyContent({
            content: t("landing.feedback.greeting", { name: feedbackName }),
            size: "medium",
            textColor: "greyMedium",
            isBold: true,
          })}
          {GetTypographyContent({
            content: t("landing.feedback.message"),
            size: "small",
            textColor: "greyMedium",
          })}
        </LandingFeedbackCardText>
        <LandingFeedbackButtonWrapper>
          <Button
            label={t("landing.feedback.button")}
            startIcon={<FontAwesomeIcon icon={faMegaphone} />}
            size={buttonSize}
            onClick={() => {
              setFeedbackSource("manual");
              setIsFeedbackModalOpen(true);
            }}
            disabled={!!isFeedbackModalOpen}
            backgroundColor="redMedium"
            reverse
          />
        </LandingFeedbackButtonWrapper>
      </StyledFeedbackCard>
    </LandingFeedbackContainer>
  );
};
